import React from 'react';
import { useQuery } from '@apollo/client';
import TrackerHistoryQuery from './TrackerHistoryQuery';

type result = {
  loading: boolean;
  trackerHistoryData?: any;
};

interface ITrackerConnectorApolloProps {
  children: (result: result) => React.ReactElement;
  startDate: string;
  endDate: string;
}

export const TrackerConnectorApollo: React.FC<ITrackerConnectorApolloProps> = ({
  children,
  startDate,
  endDate,
}) => {
  const { loading, data, error } = useQuery(TrackerHistoryQuery, {
    variables: {
      startDate,
      endDate,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.trackerHistoryData = data.dailyTracker.history;
  }

  return children(result);
};

export default TrackerConnectorApollo;
